<template>
  <div class="active-info-page">
    <navBar></navBar>

    <div class="activeimg">
      <img :src="activeinfo?.thumb" alt="" />
    </div>
    <van-row class="info">
      <van-col :span="24" class="title">
        {{ activeinfo?.title }}
      </van-col>
      <van-col :span="24">
        <img src="@/assets/images/active-time.png" alt="" />
        活动时间：
        <span>{{ activeinfo?.startTime }}</span>
      </van-col>
      <van-col :span="24" class="regTime">
        <img src="@/assets/images/active-date.png" alt="" />
        报名时间：
        <div>
          {{ activeinfo?.registrationStartTime }} -
          {{ activeinfo?.registrationEndTime }}
        </div>
      </van-col>
      <van-col :span="24" class="address">
        <img src="@/assets/images/active-adress.png" alt="" />
        <p>活动地点：</p>
        <div>{{ activeinfo?.location }}</div>
      </van-col>
      <van-col
        :span="24"
        v-for="(item, index) in activeinfo?.expandFields"
        :key="index"
      >
        <!-- <img src="@/assets/images/active-date.png" alt="" /> -->
        {{ item.label }}：
        <span>{{ item.value }}</span>
      </van-col>
      <!-- <van-col :span="24" class="file">
        <img src="@/assets/images/active-link.png" alt="" />
        供应链金融专家(CSCF)简介.doc
      </van-col> -->
    </van-row>
    <van-tabs v-model="activeName" color="#303030" title-active-color="#2553E2">
      <van-tab title="活动介绍" name="a">
        <info :data="activeinfo?.contents" />
      </van-tab>
      <van-tab
        title="活动日程"
        name="b"
        v-if="activeinfo?.schedule != null && activeinfo?.schedule != ''"
      >
        <info :data="activeinfo?.schedule" />
      </van-tab>
      <van-tab
        title="相关信息"
        name="c"
        v-if="
          activeinfo?.organizer != null ||
          activeinfo?.coOrganizer != null ||
          activeinfo?.contactPerson != null ||
          activeinfo?.phone != null ||
          activeinfo?.email != null
        "
      >
        <relevant :data="activeinfo" />
      </van-tab>
    </van-tabs>
    <div class="subbtn">
      <van-button
        class="submit"
        @click="toRegist()"
        round
        v-if="activeinfo?.registrationStatus == 'no'"
        >立即报名</van-button
      >
      <!-- :disabled="" -->
      <van-button
        class="submit wait"
        round
        v-else-if="activeinfo?.registrationStatus == 'normal'"
        @click="tosign()"
        >报名成功，请等待审核</van-button
      >
      <van-button
        class="submit view"
        round
        v-else-if="activeinfo?.registrationStatus == 'success'"
        @click="tosign()"
        >查看签到二维码</van-button
      >
      <van-button
        class="submit fail"
        round
        v-else-if="activeinfo?.registrationStatus == 'fail'"
        @click="toshowtip()"
        >审核未通过</van-button
      >
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import navBar from "@/components/navBar.vue";
import info from "./components/info.vue";
import relevant from "./components/relevant.vue";
import { eventInfoDetail } from "@/api/home/index";
import wx from "weixin-js-sdk";

import { wxShareInit } from "../../api/home/index";

export default {
  components: {
    navBar,
    info,
    relevant,
  },
  data() {
    return {
      activeName: "a",
      id: null,
      activeinfo: null,
      sources: null,
    };
  },

  methods: {
    toRegist() {
      if (this.activeinfo.status == "NotStarted") {
        Toast("当前活动未开始");
      } else if (this.activeinfo.status == "Ended") {
        Toast("当前活动已结束");
      } else {
        this.$router.push({
          path: "/register",
          query: {
            id: this.id,
            sources: this.sources,
          },
        });
      }
    },
    wxConfig(params) {
      console.log("params", params);
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: params.appId, // 必填，公众号的唯一标识
        timestamp: params.timestamp, // 必填，生成签名的时间戳
        nonceStr: params.nonceStr, // 必填，生成签名的随机串
        signature: params.signature, // 必填，签名
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表，具体可以查看JS接口列表：<https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#63>
      });
      wx.error((res) => {
        console.log("wx:err", res);
      });
      wx.ready(() => {
        wx.updateAppMessageShareData({
          title: params.shareTitle, // 分享标题，可选
          desc: params.shareDesc, // 分享描述，可选
          link: location.href,
          imgUrl: params.shareThumb, // 分享图标，可选 //  link: shareLink, // 分享链接，可选，默认当前页面
          success: function () {
            // 分享成功回调函数，可选
            // sharedSuccessCallback?.() // 有些不支持这种写法，可以写成下面这种
            sharedSuccessCallback && sharedSuccessCallback();
          },
        });
        //分享到朋友圈
        wx.updateTimelineShareData({
          title: params.shareTitle, // 分享标题，可选
          desc: params.shareDesc, // 分享描述，可选
          link: location.href,
          imgUrl: params.shareThumb, // 分享图标 //  link: shareLink, // 分享链接
          success: function () {
            sharedSuccessCallback && sharedSuccessCallback();
          },
        });
      });
    },
    getavtive() {
      const route = this.$route;
      eventInfoDetail(this.id, route).then((res) => {
        console.log(res, "res");
        this.activeinfo = res;
        wxShareInit({ url: location.href }).then((data) => {
          let obj = {};
          if (res.shareTitle != "" || !res.shareTitle) {
            obj.shareTitle = res.shareTitle || "";
          } else {
            obj.shareTitle = data.shareContent.shareTitle || "";
          }
          if (res.shareDesc != "" || !res.shareDesc) {
            obj.shareDesc = res.shareDesc || "";
          } else {
            obj.shareDesc = data.shareContent.shareDesc || "";
          }
          if (res.shareThumb != "" || !res.shareThumb) {
            obj.shareThumb = res.shareThumb || "";
          } else {
            obj.shareThumb = data.shareContent.shareThumb || "";
          }

          this.wxConfig({ ...data.shareConfig, ...obj });
        });
      });
    },
    tosign() {
      this.$router.push({
        path: "/sign",
        query: {
          id: this.activeinfo.eventMetadataData.id,
        },
      });
    },
    toshowtip() {
      Toast.fail("驳回原因:" + this.activeinfo.eventMetadataData.failTip);
    },
  },
  created() {
    document.documentElement.classList.add("active-info-page-root");
    this.id = this.$route.query.id;
    this.sources = this.$route.query.sources;
    this.getavtive();
  },
  beforeDestroy() {
    document.documentElement.classList.remove("active-info-page-root");
  },
};
</script>
<style lang="scss" scoped>
.activeimg {
  margin-top: 50px;

  img {
    width: 100%;
    height: 200px;
  }
}

.info {
  padding: 20px;
  text-align: left;
  font-size: 14px;
  line-height: 30px;
  border-bottom: 10px solid #f8f8f8;
  padding-right: 0;

  .van-col {
    display: flex;
    align-items: center;

    img {
      margin-right: 10px;
      width: 20px;
    }
  }

  .title {
    font-size: 18px;
    font-weight: bold;
  }

  .address,
  .regTime {
    align-items: start;

    p {
      width: 70px;
    }

    div {
      width: calc(100% - 110px);
    }

    img {
      margin-top: 4px;
    }
  }

  .file {
    color: #2553e2;
  }
}

:deep .van-tabs {
  margin-bottom: 70px;

  .van-tabs__line {
    background: url("../../assets/images/tabs-line.png") no-repeat center center;
    background-color: rgba($color: #000000, $alpha: 0) !important;
    width: 80px;
  }

  .van-tabs__content {
    padding: 30px 22px;
  }
}

.submit {
  width: calc(100% - 44px);
  background: #2553e2;
  color: #fff;
  margin: 20px 22px;
  box-sizing: border-box;
}

.subbtn {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0px;
  background-color: #fff;
}

.wait {
  background: #f0984d;
}

.view {
  background: #3db365;
}

.fail {
  background: #c92e2d;
}

@media screen and (min-width: 768px) {
  .active-info-page {
    min-height: 100vh;
    padding-bottom: 88px;
    box-sizing: border-box;
    background: #f7f8fa;
  }

  .activeimg {
    width: calc(100% - 64px);
    max-width: 1200px;
    margin: 68px auto 0;

    img {
      display: block;
      height: 420px;
      border-radius: 8px;
      object-fit: cover;
    }
  }

  .info {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 36px;
    row-gap: 10px;
    box-sizing: border-box;
    width: calc(100% - 64px);
    max-width: 1200px;
    margin: 24px auto;
    padding: 28px 32px;
    border: 0;
    border-radius: 8px;
    background: #fff;

    .van-col {
      width: auto;
      padding: 0;
    }

    .title {
      grid-column: 1 / -1;
      margin-bottom: 6px;
      font-size: 24px;
    }

    .address {
      grid-column: 1 / -1;
    }
  }

  :deep(.van-tabs) {
    width: calc(100% - 64px);
    max-width: 1200px;
    margin: 0 auto 88px;
    overflow: hidden;
    border-radius: 8px;
    background: #fff;

    .van-tabs__content {
      padding: 32px;
    }
  }

  .subbtn {
    padding: 4px 0;
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);

    .submit {
      display: block;
      width: 240px;
      margin: 12px auto;
    }
  }
}
</style>
<style lang="scss">
@media screen and (min-width: 768px) {
  html.active-info-page-root {
    font-size: 2.34375rem !important;
  }
}
</style>
